import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { UNLOADED_TEXTURE_ALPHA } from '../utils/textures';
import { DETACHED_SIGNAL, INACTIVE_SIGNAL, SELECTED_SIGNAL } from '../signals';
import { CoverFocus } from './focus.component';
import { colors, getInitialStyle, focusedStyle, unFocusedStyle, defaultContext } from './cover.style';
import { templates, sizes, imageOptions } from './cover.constants';

export default class Cover extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          type: CoverFocus,
        },
        Image: {
          rtt: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _inactive() {
    this.signal(INACTIVE_SIGNAL, this);
  }

  _detach() {
    this.tag('Image').removeAllListeners('txLoaded');
    this._item = undefined;
    this.signal(DETACHED_SIGNAL, this);
  }

  get item() {
    return this._item;
  }

  set item({ content, colorScheme: colorMode }) {
    if (this._item && this._item.id === content.id) {
      this._item = content;

      return;
    }

    this._item = content;
    if (this._style.colorMode !== colorMode) {
      this._style = { screenSize: this._style.screenSize, colorMode };
    }
    const { image, title } = this._item;

    this.tag('Image').once('txLoaded', () => {
      this.tag('Image').setSmooth('alpha', 1);
    });

    this.patch({
      Border: {
        colorMode,
      },
      Image: {
        alpha: UNLOADED_TEXTURE_ALPHA,
        src: image.src,
      },
      Label: {
        visible: Boolean(title),
        color: colors.text[colorMode],
        text: {
          text: title,
        },
      },
    });
  }

  _focus() {
    this.patch(focusedStyle);
  }

  _unfocus() {
    this.patch(unFocusedStyle);
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._item);

    return true;
  }
}

Cover.Templates = templates;
Cover.Sizes = sizes;
Cover.ImageOptions = imageOptions;
